export default "__VITE_ASSET__7dbba8f3__"